/* eslint-disable */

function getProductId(id) {
  return 'product-' + id;
}

function getVariantsId(id) {
  return 'product-' + id + '-variants';
}

function variantChange(variant, selector) {
  var productId = getProductId(selector.product.id);
  var parent = document.getElementById(productId);

  if (parent) {
    var form = parent.querySelector('.add-to-cart-form');

    if (form) {
      var addToCartButton = form.querySelector('.add-to-cart-button');
      
      form.setAttribute('data-variant-id', variant.id);
      
      if (variant) {
        if (variant.available) {
          parent.setAttribute('data-product-available', 'true');
          // Selected a valid variant that is available.form.setAttribute('data-variant-id', variant.id);
          addToCartButton.classList.remove('disabled');
          addToCartButton.removeAttribute('disabled');
          addToCartButton.innerHTML = window.texts.add_to_cart;
        } else {
          parent.setAttribute('data-product-available', 'false');
          // Variant is sold out.
          addToCartButton.classList.add('disabled');
          addToCartButton.setAttribute('disabled', 'true');
          addToCartButton.innerHTML = window.texts.sold_out;
        }
        // Whether the variant is in stock or not, we can update the price and compare at price.
        if (variant.compare_at_price > variant.price) {
          // console.log('todo');
          // $('#price-field').html(
          //   '<span class="product-price on-sale">' +
          //     Shopify.formatMoney(variant.price, '') +
          //     '</span>' +
          //     '&nbsp;<s class="product-compare-price">' +
          //     Shopify.formatMoney(
          //       variant.compare_at_price,
          //       ''
          //     ) +
          //     '</s>'
          // );
        } else {
          // productPrice.innerHTML = Shopify.formatMoney(variant.price, '');
        }
      } else {
        // variant doesn't exist.
        parent.setAttribute('data-product-available', 'false');
        addToCartButton.classList.add('disabled');
        addToCartButton.setAttribute('disabled', 'true');
        addToCartButton.innerHTML = 'Unavailable';
      }
    } else {
      if (variant) {
        parent.setAttribute('data-variant-id', variant.id);
      }
    }
  }
}

function linkVariants(product, parent) {
  var Shopify = Shopify || {};
  Shopify.optionsMap = {};
  Shopify.disabledMap = {};

  var productId = getProductId(product.id);
  var productEl = document.getElementById(productId);
  var optionsSelectors = productEl.querySelectorAll('.single-option-selector');

  Shopify.arrayIncludes = function(e, t) {
      for (var n = 0; n < e.length; n++)
          if (e[n] == t)
              return !0;
      return !1
  };

  Shopify.uniq = function(e) {
      for (var t = [], n = 0; n < e.length; n++)
          Shopify.arrayIncludes(t, e[n]) || t.push(e[n]);
      return t
  };

  Shopify.updateOptionsInSelector = function(selectorIndex) {
    switch (selectorIndex) {
      case 0:
        var key = 'root';
        var selector = optionsSelectors[0];
        break;
      case 1:
        var key = optionsSelectors[0].value;
        var selector = optionsSelectors[1];
        break;
      case 2:
        var key = optionsSelectors[0].value;  
        key += ' / ' + optionsSelectors[1].value;
        var selector = optionsSelectors[2];
    }
    
    // var initialValue = selector.value;

    if (selector) {
      var i, L = selector.options.length - 1;
      for(i = L; i >= 0; i--) {
        selector.remove(i);
      }
    }
    
    var availableOptions = Shopify.optionsMap[key];
    var disabledOptions = Shopify.disabledMap[key];

    if (availableOptions) {
      for (var i=0; i<availableOptions.length; i++) {
        var option = availableOptions[i];
        var newOption = document.createElement('option');
        newOption.value = option;
        newOption.innerHTML = option;
        
        if (disabledOptions[i] === -1) {
          newOption.disabled = true;
        }
        
        selector.appendChild(newOption);
      }

      selector.dispatchEvent(new Event('change'));
    }

    // if (availableOptions.indexOf(initialValue) !== -1) {
    //   selector.value = initialValue;
    // }

  };
  
  Shopify.linkOptionSelectors = function(product) {
    // Building our mapping object.
    for (var i=0; i<product.variants.length; i++) {
      var variant = product.variants[i];
      var key = 'root';

      // Gathering values for the 1st drop-down.
      Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
      Shopify.disabledMap[key] = Shopify.disabledMap[key] || [];
      Shopify.optionsMap[key].push(variant.option1);
      Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);

      if (product.options.length === 1) {
        if (!variant.available) {
          Shopify.disabledMap[key].push(-1);
        } else {
          Shopify.disabledMap[key].push(1);
        }
      }

      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        var key = variant.option1;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.disabledMap[key] = Shopify.disabledMap[key] || [];
        Shopify.optionsMap[key].push(variant.option2);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);

        if (!variant.available) {
          Shopify.disabledMap[key].push(-1);
        } else {
          Shopify.disabledMap[key].push(1);
        }
      }

      // Gathering values for the 3rd drop-down.
      // if (product.options.length === 3) {
      //   var key = variant.option1 + ' / ' + variant.option2;
      //   Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
      //   Shopify.disabledMap[key] = Shopify.disabledMap[key] || [];
      //   Shopify.optionsMap[key].push(variant.option3);
      //   Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);

      //   if (!variant.available) {
      //     Shopify.disabledMap[key].push(-1);
      //   } else {
      //     Shopify.disabledMap[key].push(1);
      //   }
      // }
    }
    
    // Update options right away.
    Shopify.updateOptionsInSelector(0);
    if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    
    // When there is an update in the first dropdown.
    if (optionsSelectors[0]) {
      optionsSelectors[0].addEventListener('change', function() {
        Shopify.updateOptionsInSelector(1);
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
        return true;
      });
    }

    // When there is an update in the second dropdown.
    if (optionsSelectors[1]) {
      optionsSelectors[1].addEventListener('change', function() {
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
        return true;
      });
    }
  };
  
  Shopify.linkOptionSelectors(product);
}

function appendNewOptions(select, selectWrapper, colors, sizes, productId) {
  var wrapper = document.createElement('DIV');
  wrapper.classList.add('shop-variants-items');
  
  for (var k = 0; k < select.options.length; k++) {
    var option = select.options[k];
    var isDisabled = select.options[k].getAttribute('disabled');
    
    if (select.isColor === 0) {  
      colors.push(option.value);
      wrapper.classList.add('shop-colors-list');
    }

    if (select.isSize === 0) {
      sizes.push(option.value);
    }

    // Parse visually variants into buttons
    var button = document.createElement('BUTTON');
    button.classList.add('shop-variants-items__option');
    button.classList.add('shop-colors-list__item');
    button.classList.add(option.value.replace(/ /g,"_").toLowerCase());
    button.setAttribute('data-value', option.value);

    if (isDisabled !== null) {
      button.disabled = true;
    }
    
    button.type = "button";
    button.selectWrapperEl = selectWrapper;
    button.selectEl = select;

    if (select.isColor === 0) {
      var buttonColor = document.createElement('SPAN');
      buttonColor.classList.add('shop-colors-list__item-color');
      buttonColor.style.backgroundColor = `${window.variants_colors[productId][option.value]}`;
      button.appendChild(buttonColor);
    }

    var buttonLabel = document.createElement('SPAN');
    buttonLabel.classList.add('shop-variants-items__option-label');
    buttonLabel.classList.add('shop-colors-list__item-label');
    buttonLabel.innerHTML = option.value;
    button.appendChild(buttonLabel);

    if (select.selectedSize === button.getAttribute('data-value') && button.disabled) {
      var firstButton = wrapper.querySelector('button:first-child');

      if (firstButton) {
        firstButton.classList.add('is-current');
      } else {
        button.classList.add('is-current');
      }
    } else {
      if (option.value === select.value) {
        button.classList.add('is-current');
      }
    }

    if (isDisabled === null) {
      button.addEventListener('click', function(e) {
        var el = e.currentTarget;
        var currentOption = el.selectWrapperEl.querySelector('.is-current');
        if (currentOption) {
          currentOption.classList.remove('is-current');
        }

        if (el.selectEl.isSize === 0) {
          el.selectEl.selectedSize = el.getAttribute('data-value');
        }
  
        el.selectEl.value = el.getAttribute('data-value');
        el.selectEl.dispatchEvent(new Event('change'));
        el.classList.add('is-current');
      });
    }

    wrapper.appendChild(button);
  }

  selectWrapper.appendChild(wrapper);
}

function parseVariants() {
  if (!window.pageProducts) return;
  
  for (var a = 0; a < window.pageProducts.length; a++) {
    var productId = getProductId(window.pageProducts[a].id);
    var variantsId = getVariantsId(window.pageProducts[a].id);
    var parent = document.getElementById(productId);
    
    var product = document.getElementById(productId);
    if (!product) return;
    
    new Shopify.OptionSelectors(variantsId, { product: window.pageProducts[a], onVariantSelected: variantChange});
    linkVariants(window.pageProducts[a], parent);

    var selectWrappers = product.querySelectorAll('.selector-wrapper');
    var selects = product.querySelectorAll('.selector-wrapper select');
    product.setAttribute('data-option-size', '[]');
    product.setAttribute('data-option-color', '[]');

    var price = Shopify.formatMoney(window.pageProducts[a].price, '{{amount}}');
    product.setAttribute('data-price', price);

    for (var i = 0; i < selectWrappers.length; i++) {
      var label = selectWrappers[i].querySelector('label');
      
      var labelValue = 'size';
      
      if (label) {
        labelValue = label.innerHTML.toLowerCase().replace(/ /g, '-');
      } else {
        label = document.createElement('label');
        label.innerHTML = "Size";

        selectWrappers[i].prepend(label);
      }

      selectWrappers[i].classList.add(labelValue);

      var isColor = labelValue.search("color");

      if (isColor === -1) {
        var isColor = labelValue.search("couleur");
      }

      var isSize = labelValue.search("size");
      if (isSize === -1) {
        var isSize = labelValue.search("taille");
      }

      var colors = [];
      var sizes = [];
      
      selectWrappers[i].classList.add(labelValue);

      if (isColor === 0 && parent) {
        var definedColor = parent.getAttribute('data-product-color');

        if (definedColor && window.variants_colors[window.pageProducts[a].id][definedColor]) {
          selects[i].value = definedColor;
        }
      }
      
      // New div to wrap new buttons
      
      selects[i].index = i;
      selects[i].isColor = isColor;
      selects[i].isSize = isSize;

      selects[i].addEventListener('change', function(e) {
        var index = e.currentTarget.index;
        const prevOptions = selectWrappers[index].querySelectorAll('.shop-variants-items');
        for (let j = 0; j < prevOptions.length; j++) {
          selectWrappers[index].removeChild(prevOptions[j]);
        }
        appendNewOptions(selects[index], selectWrappers[index], colors, sizes, window.pageProducts[a - 1].id);
      });

      appendNewOptions(selects[i], selectWrappers[i], colors, sizes, window.pageProducts[a].id);

      
      selects[i].style.display = "none";
      
      if (isSize === 0 && sizes) {
        product.setAttribute(`data-option-size`, JSON.stringify(sizes));
      }

      if (isColor === 0 && colors) {
        product.setAttribute(`data-option-color`, JSON.stringify(colors));
      }
    }
  }
}